import type { DeepPartial } from '@luna/utils-ts';

import type { LoanFeatureConfig } from '../types/LoanFeatureConfig';
import { earlyLoanRepayment } from './configByFeature/earlyLoanRepayment/SK';

export const loans: DeepPartial<LoanFeatureConfig> = {
    dashboard: {
        showInstallmentFrequency: true,
    },
    overview: {
        enabled: true,
        showTransactions: true,
        showAdditionalInfo: true,
        showEarlyLoanRepaymentActionButton: true,
        showLoanCurrency: true,
        displayDedicatedMortgageInfos: true,
    },
    additionalDetails: {
        showOverdueInfo: true,
        showExtraInstallment: true,
    },
    transactions: {
        enabled: true,
        mode: 'always',
    },
    statements: {
        enabled: true,
        deliveryDefinitions: {
            distribution: ['GEORGE', 'GEORGE_AND_EMAIL'],
            format: ['PDF_A4'],
            periodicity: ['DAILY', 'MONTHLY', 'YEARLY'],
            canCreateDefinition: true,
            statementNumberEditable: true,
        },
        showDeliveryDefinitions: true,
    },
    settingsDetails: {
        displayAccountOwner: true,
        displayIban: true,
        displaySlashedBBAN: true,
        displayBIC: true,
    },
    earlyLoanRepayment,
    layout: {
        productInfo: {
            formatAccountNumber: true,
        },
    },
};
